module.exports = __webpack_public_path__ + "assets/images/CNY20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CNY20.png
// module id = 1345
// module chunks = 1